import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Radio,
} from '@cambridgeassessment/cambridge-ui';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import clsx from 'clsx';
import React from 'react';
import { useStyles } from '../Select/styles';

const ChangeOrganisationAccordianList = ({
  options,
  onSelect,
  className,
  selected,
}) => {
  const classes = useStyles();

  // Helper function to check if the selected ID is a child of the current parent
  const isChildSelected = (childs) => {
    return childs.some((child) => child.id === selected);
  };

  // Add state to track expanded items
  const [expanded, setExpanded] = React.useState<string | false>(false);

  // Handle accordion change
  const handleChange =
    (id: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? id : false);
    };

  return (
    <div>
      {options.map(({ id, label, childOnly, childs }) => (
        <Accordion
          key={id}
          TransitionProps={{ unmountOnExit: true }}
          expanded={
            childs.length > 0
              ? expanded === id || id === selected || isChildSelected(childs)
              : false
          }
          onChange={childs.length > 0 ? handleChange(id) : undefined}
        >
          <AccordionSummary
            expandIcon={childs.length > 0 ? <ExpandMoreIcon /> : null}
            style={childs.length === 0 ? { cursor: 'default' } : undefined}
          >
            <Radio
              disabled={childOnly}
              bold
              className={clsx(classes.radio, className)}
              key={id}
              color="primary"
              data-testid={`select-option-${id}`}
              label={childs.length > 0 ? `${label} (${childs.length})` : label}
              name={id}
              onChange={() => onSelect(id)}
              checked={id === selected}
            />
          </AccordionSummary>
          {childs.length > 0 && (
            <AccordionDetails onClick={(e) => e.stopPropagation()}>
              <Box ml={5}>
                {childs.map(({ id, label }) => (
                  <Radio
                    bold
                    className={clsx(classes.radio, className)}
                    key={id}
                    color="primary"
                    data-testid={`select-child-option-${id}`}
                    label={label}
                    name={id}
                    onChange={() => onSelect(id)}
                    checked={id === selected}
                  />
                ))}
              </Box>
            </AccordionDetails>
          )}
        </Accordion>
      ))}
    </div>
  );
};

export default ChangeOrganisationAccordianList;
